<template>
  <div class="box">
    <div class="login_box">
      <!-- <div style="float: left;">
        <el-image style="width: 100px; height: 100px;padding-top:50px" :src="loginImg" :fit="fit"></el-image>
      </div>-->
      <div style="width:550px">
        <!--   <div style="padding-left: 40%;"> -->
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm" style="width:60%;padding-left:40%;">
          <H2 style="text-align:center">{{ webTitle }}</H2>
          <el-row>
            <el-form-item prop="account">
              <el-input name="account" style="width:100%" type="text" v-model="loginForm.account" placeholder="手机号" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="password">
                <el-input class="login_pwd" name="password" @keyup.enter.native="handleLogin" v-model="loginForm.password"
                  placeholder="验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="el_form_button">
                <el-button :disabled="sendAuthCode" type="primary"
                  @click.native="getAuthCode">获取验证码{{ auth_time }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="el_form_item">
            <el-button :loading="btnLoading" size="small" style="width:100%" class="login_btn"
              @click.native.prevent="login(2)" type="primary" v-preventReClick>登录</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" style="width:100%" @click="showWx">企业微信授权登录</el-button>
          </el-form-item>
          <div>
            <span style="float:left">
              没有账号？
              <el-button type="text" @click.native="register()">注册公司</el-button>
            </span>
          </div>
        </el-form>
      </div>

    </div>
    <dialog-panel :title="companyBoardTitle" :dialogController="companyBoard" width="500px" :top="'30vh'"
      @cancel="cancelChooseCompany" :showCancel="false" :showConfirm="false">
      <template v-for="(column, cIndex) in companyColumns">
        <div :key="cIndex" style="display:inline-block;margin:5px 10px">
          <i class="el-icon-office-building" style="color:#409EFF"></i>
          <el-button @click.native="checkCompany(column.id)" type="text" v-preventReClick>{{ column.name }}</el-button>
        </div>
      </template>
    </dialog-panel>
    <companyRegister :onSave="onAdd" ref="registerDialog"></companyRegister>

    <dialog-panel class="bindDialog" :title="wxBoardTitle" :dialogController="wxFlag" width="60%" @cancel="cancelBind"
      :showCancel="false" :showConfirm="false">
      <div class="box1" v-if="step == 1">
        <div class="qrcode">
          <iframe :src="loginHtml" frameborder="0" class="innerCode"></iframe>
        </div>
        <!-- <div v-html="loginHtml"></div> -->
        <!-- <div class="box1-bottom">
            <div>请使用企业微信扫描二维码</div>
            <div>登录EPM系统</div>
          </div>-->
      </div>

      <div class="box2" v-else>
        <!-- <div class="box2-item1">已向您的手机</div>
          <div class="box2-item2">14567898345</div>
          <div class="box2-item3">发送了验证码，请输入您收到的验证码进行与企业微信相互绑定</div>-->
        <div class="box2-item4">
          <span style="color:red">*</span>
          <span style="font-size:12px">手机号：</span>
          <el-input placeholder="请输入" style="width:200px;" size="mini" v-model="bindAccount"></el-input>
        </div>
        <div class="box2-item4">
          <span style="color:red">*</span>
          <span style="font-size:12px">验证码：</span>
          <el-input placeholder="请输入" style="width:200px;" size="mini" v-model="bindIdentify"></el-input>
        </div>
        <div class="box2-item5">
          <!-- <el-button size="small" style="width:80px">重新发送</el-button> -->
          <el-button :disabled="sendAuthCode1" size="small"
            @click.native="getAuthCode1(7)">获取验证码{{ auth_time1 }}</el-button>
          <el-button type="primary" style="width:80px" size="small" @click="sureBind">确定</el-button>
        </div>
      </div>
    </dialog-panel>
  </div>
</template>

<script>
import { validEmpty } from "utils/validate";
import {
  loginByJava,
  getloginPrepositive,
  getCaptcha,
  getQrCode,
  bindWxWork,
  verifyIdentifier
} from "./loginAPI";
import * as _ from "utils/validate";
import companyRegister from "./companyRegister";
let companyId = "";
let loginCodePara = "";
export default {
  name: "login",
  data() {
    const validateEmpty = (rule, value, callback) => {
      if (validEmpty(value)) {
        callback(
          new Error(
            `请输入正确的${rule.field == "account" ? "手机号" : "验证码"}`
          )
        );
      } else {
        callback();
      }
    };
    return {
      loginImg: "../../assets/logo.png",
      loginForm: {
        account: "",
        password: ""
      },
      companyBoard: false,
      companyBoardTitle: "选择公司",
      companyColumns: [],
      // isBtnLoading: false,
      btnLoading: false,
      sendAuthCode: false, // 启用
      auth_time: "",
      sendAuthCode1: false, // 启用
      auth_time1: "",
      loginRules: {
        account: [
          { required: true, trigger: "blur", validator: validateEmpty }
        ],
        password: [
          { required: true, trigger: "blur", validator: validateEmpty }
        ]
      },
      wxBoardTitle: "",
      wxFlag: false,
      step: 1,
      loginHtml: "",
      bindAccount: "",
      bindIdentify: "",
      identifier: ""
    };
  },
  created() {
    let token = this.$route.query.token;
    console.log('asd', window.location);
    let code = this.getQueryString('code') || this.$route.query.code
    if (code) {
      window.location = 'https://epm.tentcoo.com:34000/#/index?code=' + code
      return
    }
    if (this.getQueryString('auth_code')) {
      let auth = this.getQueryString('auth_code')
      let state = this.getQueryString('state')
      let newQuery = {
        auth_code: auth,
        state
      }
      this.$router.replace({ query: newQuery })
      this.checkBindWx();
    }
    if (token) {
      try {
        let data = JSON.parse(decodeURIComponent(escape(window.atob(token))));
        this.$nextTick(() => {
          this.loginForm.account = data.account;
          this.loginForm.password = data.password;
          this.handleLogin();
        });
      } catch (error) {
        // 跳转指定页面
        // window.location.href = 'http://39.108.8.229:10000/?tis=错误'/**测试 */
        return;
        // window.location.href = 'http://183.232.110.233:10000/?tis=错误'
      }
    }
    //已经登录了
    if (localStorage.jwtToken) {
      this.$router.push("/")
    }

    // if (JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user')).account) {
    //   this.account = JSON.parse(localStorage.getItem('user')).account
    //   this.password = JSON.parse(localStorage.getItem('user')).password
    // }
  },
  computed: {
    // btnText () {
    //   if (this.isBtnLoading) return '登录中...'
    //   return '登录'
    // }
  },
  components: {
    companyRegister
  },
  methods: {
    funlogin() {
      this.btnLoading = true;
      let params = {
        companyId: this.companyId,
        loginCode: this.loginCodePara
      };
      loginByJava(params).then(res => {
        if (res.code === 1000) {
          // res.data.sysPermissionList= [], // 模拟数据
          this.btnLoading = false;
          localStorage.setItem("currentUser", JSON.stringify(res.data))
          localStorage.setItem("jwtToken", res.data.jwtToken)
          localStorage.setItem("permissions", JSON.stringify(res.data.sysPermissionList)) // 菜单权限
          localStorage.setItem("funPermissions", JSON.stringify(res.data.functionAuthority)) // 按钮权限
          localStorage.setItem("projectAuthority", JSON.stringify(res.data.projectAuthority)) // 项目权限
          localStorage.setItem("adminFlag", JSON.stringify(res.data.adminFlag)) // 超级管理员标识
          if (this.$route.query.token) {
            localStorage.setItem("fromMultiportLogin", true)
          }
          if (this.$route.query.auth_code) {
            window.location = window.location.origin + '/#/my-workbench/MyWorkbench'
          } else this.$router.push("/"); // push 点回退返回上一个页面

          //this.$router.replace('/main'); // replace 会替换浏览器历史记录
        } else {
          this.btnLoading = false;
          // this.$message.warning(res.message+"cuod");
          if (this.$route.query.token) {
            // 跳转指定页面
            // window.location.href = 'http://39.108.8.229:10000/?tis=' + res.message/**测试 */
            return;
            // window.location.href = 'http://183.232.110.233:10000/?tis=' + res.message
          }
        }
      }).catch(err => {
        if (this.$route.query.token) {
          // 跳转指定页面
          // window.location.href = 'http://39.108.8.229:10000/?tis=' + err/**测试 */
          return;
          // window.location.href = 'http://183.232.110.233:10000/?tis=' + err
        }
      })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    },
    checkCompany(cId) {
      console.log("cidd", cId);
      this.companyId = cId;
      this.companyBoard = false;
      this.funlogin();
    },
    cancelBind() {
      this.wxFlag = false
      this.step = 1
      if (this.$route.query.auth_code) {
        let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 深拷贝
        delete newQuery.auth_code
        delete newQuery.state
        delete newQuery.appid
        console.log(newQuery, 'newquery')
        this.$router.replace({ query: newQuery })
        window.location = window.location.origin + '/#/login'
      }
    },
    cancelChooseCompany() {
      this.companyBoard = false
      this.loginForm.account = ''
      this.loginForm.password = ''
      if (this.$route.query.auth_code) {
        let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 深拷贝
        delete newQuery.auth_code
        delete newQuery.state
        delete newQuery.appid
        console.log(newQuery, 'newquery')
        this.$router.replace({ query: newQuery })
        window.location = window.location.origin + '/#/login'
      }
    },
    checkBindWx() {
      if (!this.$route.query.auth_code) {
        return;
      }
      let params = {
        authCode: this.$route.query.auth_code,
        state: this.$route.query.state
      };
      verifyIdentifier(params).then(res => {
        console.log(res);
        this.identifier = res.data.identifier;
        if (res.data.status == 0) {
          this.step = 2;
          this.wxFlag = true;
          this.wxBoardTitle = "关联手机";
        } else if (res.data.status == 1) {
          // this.loginForm.account = this.identifier;
          // this.loginForm.password = this.$route.query.auth_code;
          this.login(3, this.identifier, this.$route.query.auth_code);
        }
      });
    },
    sureBind() {
      if (!this.bindAccount) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.bindIdentify) {
        this.$message.error("请输入验证码");
        return;
      }
      let params = {
        authCode: this.bindIdentify,
        identifier: this.identifier,
        mobile: this.bindAccount
      };
      bindWxWork(params).then(res => {
        if (res.code === 1000) {
          this.$message.success("绑定企业微信成功！");
          this.wxFlag = false;
          this.step = 1;
          setTimeout(() => {
            // this.loginForm.account = this.identifier
            // this.loginForm.password = this.$route.query.auth_code
            this.login(3, this.identifier, this.$route.query.auth_code);
          }, 1000);
        }
      });
    },
    register() {
      this.$refs.registerDialog.show("add", "");
    },
    onAdd() { },
    b64Decode(str) {
      return decodeURIComponent(escape(window.atob(str)));
    },
    login(e, account, password) {
      this.$refs.loginForm.validate(valid => {
        if (valid || (account && password)) {
          let loginbefore = {
            identifier: account ? account : this.loginForm.account,
            credential: password ? password : this.loginForm.password,
            type: e
          };
          // console.log('ddd',loginbefore)
          getloginPrepositive(loginbefore).then(res => {
            // if(!res) return
            console.log("返回数据", res);
            this.loginCodePara = res.data.loginCode;
            let companyVOListPara = res.data.companyVOList;
            localStorage.setItem(
              "companyVOList",
              JSON.stringify(companyVOListPara)
            );
            if (res.data.companyVOList) {
              // companyId = res.data.companyVOList[0].id
              // console.log('公司id', companyId)
              this.companyId = res.data.companyVOList[0].id;
              console.log("公司选项", companyVOListPara);
              if (res.data.companyVOList && res.data.companyVOList.length > 1) {
                this.companyColumns = companyVOListPara;
                this.companyBoard = true;
              } else {
                this.funlogin();
              }
            }
          });
        }
      });

      // if (!this.loginForm.account) {
      //   this.$message.error('请输入手机号')
      //   return
      // }
    },

    //  验证
    getAuthCode() {
      // if (this.loginForm.account.length !== 11) {
      //   this.$message.error('请输入正确的手机号码')
      //   return
      // }
      if (!_.validPhone(this.loginForm.account)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      let dataPara = {
        mobile: this.loginForm.account,
        type: 1
      };
      getCaptcha(dataPara).then(res => {
        // const url = ''
        // console.log('ur', url)
        this.sendAuthCode = true; // 禁用
        // 设置倒计时秒
        this.auth_time = 180;
        var authTimeTimer = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.auth_time = "";
            this.sendAuthCode = false; // 启用
            clearInterval(authTimeTimer);
          }
        }, 1000);
      });
    },
    getAuthCode1() {
      // if (this.loginForm.account.length !== 11) {
      //   this.$message.error('请输入正确的手机号码')
      //   return
      // }
      if (!_.validPhone(this.bindAccount)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      let dataPara = {
        mobile: this.bindAccount,
        type: 7
      };
      getCaptcha(dataPara).then(res => {
        // const url = ''
        // console.log('ur', url)
        this.sendAuthCode1 = true; // 禁用
        // 设置倒计时秒
        this.auth_time1 = 180;
        var authTimeTimer = setInterval(() => {
          this.auth_time1--;
          if (this.auth_time1 <= 0) {
            this.auth_time1 = "";
            this.sendAuthCode1 = false; // 启用
            clearInterval(authTimeTimer);
          }
        }, 1000);
      });
    },
    showWx() {
      this.wxFlag = true;
      this.wxBoardTitle = "企业微信登录";
      getQrCode().then(res => {
        // console.log('qr',res);
        if (res.code === 1000) {
          this.loginHtml = res.data;
        }
      });
    }
    // getCode(){
    //   // this.step = 2
    //   getQrCode().then(res=>{
    //     this.loginHtml = res.data
    //   })
    // }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
        // if(this.getQueryString('auth_code')){
        //   let auth = this.getQueryString('auth_code')
        //   let state = this.getQueryString('state')
        //   let newQuery = {
        //     auth_code:auth,
        //     state
        //   }
        //   this.$router.replace({ query: newQuery })
        //   this.checkBindWx();
        // }

      },
      immediate: true
    }
  }
};
</script>

<style lang="scss"  scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
}

.login_box {
  /* border: 1px solid #dcdfe6; */
  // position: relative;
  width: 600px;
  // margin: 180px auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 50px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 20px;
  box-shadow: 0 0 25px #dcdee2;
  background: url("../../assets/logo.png") no-repeat;
  background-size: 150px 150px;
  background-position: 15%;
  /* margin-bottom: 20px;
    margin-right: 3px;
    float: left; */
}

.bindDialog>>>.el-dialog__header {
  padding: 40px 20px 10px;
}

.login_pwd {
  height: 40px;
  width: 100%;
  margin-bottom: 5px;
  padding-left: 0%;
  border: 0;
  border-bottom: solid 1px lavender;
}

.el_form_item {
  /* border: 1px solid #fff;
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.2); */
  margin-bottom: 10px;
}

.el_form_button {
  padding-left: 18%;
}

.box1-top {
  display: flex;
  align-items: center;
  justify-content: center;
}

.box1-top>span {
  color: #409eff;
  font-weight: bold;
  font-size: 20px;
  margin-left: 10px;
}

.qrcode {
  // width: 350px;
  height: 400px;
  // background: #eee;
  margin: 20px auto;
  text-align: center;
}

.innerCode {
  width: 100%;
  height: 100%;
}

.box1-bottom {
  color: #999;
  text-align: center;
}

.box2 {
  text-align: center;
}

.box2-item1,
.box2-item3 {
  font-size: 12px;
  color: #999;
  margin: 20px 0;
}

.box2-item2 {
  font-size: 22px;
  letter-spacing: 2px;
}

.box2-item4 {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue